import { getQueryString } from '@/utils/common'
import { EOSType } from './consts'
import toast from 'antd-mobile/es/toast'

export const isInNative = () =>
  true || (navigator.userAgent && navigator.userAgent.includes('/shansongclient')) ||
  getQueryString('shansongclient')

export const getOSType = () => {
  const inUA = tag => (navigator.userAgent && navigator.userAgent.includes(tag))
  if (inUA('ios_ssy') || inUA('iPhone') || getQueryString('ios_ssy')) {
    return EOSType.ios
  }
  if (inUA('android_ssy') || getQueryString('android_ssy') || isOpenHarmony()) {
    return EOSType.android
  }
  return EOSType.other
}
export const isOpenHarmony = () => {
  return navigator.userAgent.includes('OpenHarmony') || navigator.userAgent.includes('openHarmony') || getQueryString('openHarmony') || getQueryString('OpenHarmony')
}
const onPageShowAndHideForIos = () => {
  let isPageHide = false
  window.addEventListener('pageshow', () => {
    if (isPageHide) {
      window.location.reload()
    }
  })
  window.addEventListener('pagehide', () => {
    isPageHide = true
  })
}
export const polyfillHistroyVersionsForIOS = () => {
  if (getOSType() === EOSType.ios) {
    onPageShowAndHideForIos()
    if (window.webkit && window.webkit.messageHandlers) {
      window.TitleControlJS = {
        handleTitle: args => {
          window.webkit.messageHandlers.handleTitle.postMessage(args)
        }
      }
      window.ObtainJsonDataJS = {
        getJsonData: args => {
          window.webkit.messageHandlers.getJsonData.postMessage(args)
        }
      }
      window.MediaJS = {
        cameraType: args =>
          window.webkit.messageHandlers.cameraType.postMessage(args),
        chooserType: args => {
          window.webkit.messageHandlers.chooserType.postMessage(args)
        }
      }
      window.lightning = {
        backable: args =>
          window.webkit.messageHandlers.backable.postMessage({ ...args })
      }
      window.lightning = {
        clothImgCallBack: args =>
          window.webkit.messageHandlers.clothImgCallBack.postMessage({ ...args })
      }
      window.orderSetting = {
        setDestination: args =>
          window.webkit.messageHandlers.setDestination.postMessage({
            ...args
          })
      }
      window.RecruitJs = {
        openIndex: args =>
          window.webkit.messageHandlers.openIndex.postMessage({
            ...args
          }),
        recruitFinish: args =>
          window.webkit.messageHandlers.recruitFinish.postMessage(args),
        openRecruitDirectory: args =>
          window.webkit.messageHandlers.openRecruitDirectory.postMessage({
            ...args
          })
      }

      window.ADhandler = {
        receiveData: args =>
          window.webkit.messageHandlers.receiveData.postMessage({ ...args })
      }

      window.SlidingValidationJs = {
        verifySuccess: args =>
          window.webkit.messageHandlers.verifySuccess.postMessage(args)
      }
    }
  }
}
export const polyfillForIOS = methodName => {
  if (getOSType() === EOSType.ios) {
    if (window.webkit && window.webkit.messageHandlers) {
      if (!window.IssJsBridgeCourier) {
        window.IssJsBridgeCourier = {}
      }
      window.IssJsBridgeCourier[methodName] = (...args) => {
        return window.webkit.messageHandlers[methodName].postMessage(args)
      }

      return window.IssJsBridgeCourier
    } else {
      toast.fail('ios jsBridge 注入失败')
    }
  } else {
    return window.IssJsBridgeCourier
  }
}
